import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./api/auth";
import { PageProvider, setCreds } from "./contexts/PageContext";
import { runningOnRobot } from "./api/host-aware";
import { UserRole } from "./models/User";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container!);

if (runningOnRobot()) {
  setCreds({
    _id: "robot_user",
    email: "robot@local",
    name: "Robot User",
    orgId: "robot_org",
    userId: "robot_user",
    tenantEmail: "robot@local",
    role: UserRole.OrgAdmin,
  }, {
    _id: "robot_org",
    name: "Robot Org",
    description: "Organization for the robot",
    token: "robot_org_token",
    imageBlobId: "",
  });
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
} else {
  root.render(
    <MsalProvider instance={msalInstance}>
      <PageProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PageProvider>
    </MsalProvider>
  );
}
